module.exports = __webpack_public_path__ + "static/Michael-Nelson-Resume-0309bf0c9e7f2b81631de9facbe09cc8.pdf";